import React from 'react';
import { Header } from '../components/Header';
import { HeroSection } from '../components/HeroSection';
import { ServiceCards } from '../components/ServiceCards';
import { NewsAlerts } from '../components/NewsAlerts';
import { Footer } from '../components/Footer';
export function HomePage() {
  return <div className="min-h-screen flex flex-col w-full" data-id="element-376">
      <Header data-id="element-377" />
      <main className="flex-grow" data-id="element-378">
        <HeroSection data-id="element-379" />
        <ServiceCards data-id="element-380" />
        <NewsAlerts data-id="element-381" />
      </main>
      <Footer data-id="element-382" />
    </div>;
}